import { Box, Link } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { FOOTER } from '../../constants/messages';
import { selectIsPrivateLabel } from '../../redux/slices/uiSettingsSlice';
import styles from './Footer.module.scss';

const Footer: React.FC = () => {
	const isPrivateLabel = useSelector(selectIsPrivateLabel);
	return (
		<Box
			component="footer"
			className={styles.footer}
			sx={(theme) => ({ borderTop: `2px solid ${theme.palette.brand.secondary}` })}
		>
			{!isPrivateLabel && (
				<>
					<Box className={styles.linksContainer}>
						<Link
							href="https://www.huntington.com/Privacy-Security"
							className={styles.footerLink}
							underline="hover"
							target="_blank"
							rel="noopener noreferrer"
						>
							Identity Protection
						</Link>
						<Link
							href="https://www.huntington.com/Privacy-Security/privacy-policies/huntingtons-security-commitment"
							className={styles.footerLink}
							underline="hover"
							target="_blank"
							rel="noopener noreferrer"
						>
							Security
						</Link>
						<Link
							href="https://www.huntington.com/Privacy-Security/privacy-policies"
							className={styles.footerLink}
							underline="hover"
							target="_blank"
							rel="noopener noreferrer"
						>
							Privacy Policy
						</Link>
						<Link
							href="/assets/static/Terms%20and%20Conditions.pdf"
							className={styles.footerLink}
							underline="hover"
							target="_blank"
							rel="noopener noreferrer"
						>
							Terms &amp; Conditions
						</Link>
					</Box>
					<Box className={styles.hrContainer}>
						<hr className={styles.footerHr} />
					</Box>
					<Box className={styles.termsContainer}>
						<div className={styles.termsText}>{FOOTER}</div>
					</Box>
				</>
			)}

			{isPrivateLabel && (
				<Box className={styles['private-label-footer']}>
					<Box className={styles.linksContainer}>
						<Link
							href="/assets/static/Terms%20and%20Conditions%20Private%20Label.pdf"
							className={styles.footerLink}
							underline="hover"
							target="_blank"
							rel="noopener noreferrer"
						>
							Terms &amp; Conditions
						</Link>
					</Box>
					<Box className={styles.hrContainer} style={{ width: '80%' }}>
						<hr className={styles.footerHr} style={{ width: '80%' }} />
					</Box>

					<Box sx={(theme) => ({ color: theme.palette.primary.main })}>
						&copy; Circadia {new Date().getFullYear()}
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default Footer;
